(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const updateImagePosition = () => {
      document.querySelectorAll('.template-collection .image-banner picture img').forEach((image) => {
        image.style.setProperty('object-position', 'right center', 'important');
      });
    };
    updateImagePosition();
    const observer = new MutationObserver(updateImagePosition);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbrgt-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
   const section = document.querySelector('.lbrgt-featured-collection');
    if (!section) return;

    const toggleBtns = section.querySelectorAll('.toggle-btn');
    const toggleSwitch = section.querySelector('.lbrgt-collection-toggle__switch');
    const toggleWrapper = section.querySelector('.lbrgt-collection-toggle');
    const carousels = section.querySelectorAll('[data-toggle-collection]');
    const viewAllLinks = section.querySelectorAll('.lbrgt-view-all');

    if (!toggleBtns.length || !carousels.length) return;

    function switchCollection(group) {
      carousels.forEach(function (carousel) {
        const isActive = carousel.dataset.toggleCollection === group;
        carousel.style.display = isActive ? '' : 'none';

        // The slider that's becoming visible was measured at 0 width while
        // hidden — tell it to remeasure and rebuild now that it's shown.
        if (isActive && carousel.hasAttribute('data-slider')) {
          requestAnimationFrame(function () {
            carousel.dispatchEvent(new Event('lbrgt:slider:refresh'));
          });
        }
      });

      viewAllLinks.forEach(function (link) {
        link.style.display = link.classList.contains('lbrgt-view-all--' + group) ? '' : 'none';
      });

      toggleBtns.forEach(function (btn) {
        const isActive = btn.dataset.toggle === group;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (toggleWrapper) {
        toggleWrapper.classList.toggle('lbrgt-collection-toggle--group2', group === 'group_2');
      }
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchCollection(btn.dataset.toggle);
      });
    });

    if (toggleSwitch) {
      toggleSwitch.addEventListener('click', function () {
        const currentActive = section.querySelector('.toggle-btn.active');
        const nextGroup = currentActive && currentActive.dataset.toggle === 'group_1' ? 'group_2' : 'group_1';
        switchCollection(nextGroup);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
